export const PAD_ITEM_TYPE = {
  MAT_MED: 1,
  EQUIPMENT: 2,
  FURNITURE: 3
};
